import React from 'react';
import PropTypes from 'prop-types';
import styles from '../../styles/Accordion.module.scss';
import { getProjectId, getTextWithNoSpace } from '../../lib/common';
import { handleImpressionsTrack } from '../../api';
import { useAuth } from '../../contexts/auth';

const Checkbox = ({
  faqData,
  checkedItems,
  showTicketCreate,
  setShowTicketCreate,
  selectedCheckboxItem,
  setSelectedCheckboxItem,
}) => {
  const [authState] = useAuth();
  const projectId = getProjectId();

  const handleChange = async (item) => {
    setSelectedCheckboxItem(item === selectedCheckboxItem ? null : item);
    if (projectId === 'csportal') {
      const liVal = 'click';
      const liTrd = `click_${getTextWithNoSpace(item.toLowerCase(), '_')}`;
      const faqTypeVal = '';
      const othersData = [];
      const llTrd = `click_${faqData?.faqKey}`;
      const llTrdInside = `faq_${faqData?.faqKey}`;
      await handleImpressionsTrack(liVal, liTrd, faqTypeVal, othersData, llTrd, authState, llTrdInside);
    }
    if (item === 'Others') {
      setShowTicketCreate((prev) => !prev);
    } else {
      setShowTicketCreate(false);
    }
  };
  const titlesObj = {
    renewalcalls: 'If you do not wish to receive calls for renewal, please choose an option below and submit',
    tempstop: 'If you wish to stop your contract temporarily, please choose an option below and submit',
    specialnumberblock: 'If you want to block your special number, please choose the options below and submit',
  };
  return (
    <>
      {['renewalcalls', 'tempstop', 'specialnumberblock'].includes(faqData?.faqKey) && (
        <>
          <div className="font12 fw600 color111 p-10">{titlesObj?.[faqData?.faqKey]}</div>
          <ul className={`${styles.Accordion__Items} p-10`}>
            <>
              {checkedItems?.map((item, idx) => (
                <li key={idx} className={`${styles.Accordion__Item}`}>
                  <label htmlFor={`checkbox_${idx}`} className={`${styles.Accordion__Radio__Lable}`}>
                    <input
                      id={`checkbox_${idx}`}
                      className={`${styles.Accordion__Radio__Input} `}
                      type="checkbox"
                      name="sidcity_radio"
                      onChange={() => handleChange(item)}
                      checked={
                        selectedCheckboxItem && item === 'Others' ? showTicketCreate : item === selectedCheckboxItem
                      }
                    />
                    <span className={`${styles.Accordion__Radio__Icon} csicon `} />
                    <span className={` ${styles.Accordion__Radio__Text} font14 fw400 color111`}>{item} </span>
                  </label>
                </li>
              ))}
            </>
          </ul>
        </>
      )}
    </>
  );
};

export default Checkbox;

Checkbox.propTypes = {
  faqData: PropTypes.object,
  showTicketCreate: PropTypes.bool,
  setShowTicketCreate: PropTypes.func,
  checkedItems: PropTypes.array,
  selectedCheckboxItem: PropTypes.string,
  setSelectedCheckboxItem: PropTypes.func,
};
